import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toHtml from 'html-react-parser';
import * as emailTemplateService from '../../../services/email.template';
import Breadcrums from '../../../common/breadcrumbs';
import Loader from '../../../common/loader';
import { formateDate, showStatus } from '../../../../../utils/commonfunction';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

const LANGUAGES = [
  { code: 'en', name: 'English', flag: 'gb' },
  { code: 'de', name: 'German', flag: 'de' },
  { code: 'hu', name: 'Hungarian', flag: 'hu' },
  { code: 'es', name: 'Spanish', flag: 'es' },
];

const ViewEmailTemp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState(null);
  const [activeLang, setActiveLang] = useState('en');

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard/1" },
    { title: t("automatic_emails"), url: "/admin/cms/default-email-template/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    emailTemplateService.Details(params.id)
      .then(response => {
        if (response?.success && response?.data) {
          setData(response.data);
        } else {
          Swal.fire({ icon: 'error', text: "Template not found", timer: 2000, showConfirmButton: false });
          navigate(-1);
        }
      })
      .catch(err => {
        console.error("Error loading template:", err);
        Swal.fire({ icon: 'error', text: "Failed to load template", timer: 2000, showConfirmButton: false });
        navigate(-1);
      });
  }, [params.id, navigate]);

  if (!data) {
    return <Loader />;
  }

  const currentLang = LANGUAGES.find(l => l.code === activeLang);

  return (
    <>
      <Breadcrums data={breadcrumbs} />

      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="main-content-label">{t("view_automatic_email")}</h6>
                <button className="btn ripple btn-dark" onClick={() => navigate(-1)}>
                  Back
                </button>
              </div>

              {/* Language Tabs */}
              <ul className="nav nav-tabs mb-4">
                {LANGUAGES.map(lang => (
                  <li className="nav-item" key={lang.code}>
                    <button
                      className={`nav-link ${activeLang === lang.code ? 'active' : ''}`}
                      onClick={() => setActiveLang(lang.code)}
                      type="button"
                    >
                      <span className={`fi fi-${lang.flag} me-2`}></span>
                      {lang.name}
                    </button>
                  </li>
                ))}
              </ul>

              <table className="table table-bordered table-hover">
                <tbody>
                  {/* Global Fields */}
                  <tr>
                    <th width="200">Slug</th>
                    <td><code>{data.slug || "N/A"}</code></td>
                  </tr>

                  <tr>
                    <th>Status</th>
                    <td>{toHtml(showStatus(data.status))}</td>
                  </tr>

                  <tr>
                    <th>Created Date</th>
                    <td>{formateDate(data.createdAt)}</td>
                  </tr>

                  <tr>
                    <th>Last Modified</th>
                    <td>{data.updatedAt ? formateDate(data.updatedAt) : "N/A"}</td>
                  </tr>

                  {/* Dynamic Options */}
                  <tr>
                    <th>Dynamic Shortcodes</th>
                    <td>
                      {data.options && data.options.length > 0 ? (
                        <div className="d-flex flex-wrap gap-2">
                          {data.options.map((opt, i) => (
                            <span key={i} className="badge badge-primary-light">
                              {'{' + opt.toUpperCase() + '}'}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <span className="text-muted">No shortcodes defined</span>
                      )}
                    </td>
                  </tr>

                  {/* Language-Specific Fields */}
                  <tr>
                    <th>Title ({currentLang?.name})</th>
                    <td>
                      <strong>{data.title?.[activeLang] || "Not translated"}</strong>
                    </td>
                  </tr>

                  <tr>
                    <th>Subject ({currentLang?.name})</th>
                    <td>{data.subject?.[activeLang] || "Not translated"}</td>
                  </tr>

                  <tr>
                    <td colSpan="2" className="p-0">
                      <div className="p-4 bg-light">
                        <h6 className="mb-3">Email Preview ({currentLang?.name})</h6>
                        <div
                          className="border rounded p-4 bg-white"
                          style={{ minHeight: "300px", fontFamily: "Arial, sans-serif" }}
                          dangerouslySetInnerHTML={{
                            __html: data.description?.[activeLang] || "<em>No content in this language</em>"
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="mt-4">
                <button className="btn ripple btn-dark" onClick={() => navigate(-1)}>
                  Back to List
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewEmailTemp;